import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/new/31.png';
import _imports_1 from '../../../assets/new/44.png';
import _imports_2 from '../../../assets/new/49.png';
import _imports_3 from '../../../assets/new/9.png';
import _imports_4 from '../../../assets/new/51.png';
const _withScopeId = n => (_pushScopeId("data-v-6b488734"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_6 = {
  class: "progress"
};
const _hoisted_7 = {
  class: "footer"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1));
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
export default {
  __name: 'level_copy',
  setup(__props) {
    const isMobile = computed(() => {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      let getArr = Agents.filter(i => userAgentInfo.includes(i));
      return getArr.length ? true : false;
    });
    const store = useStore();
    const router = useRouter();
    const userInfo = computed(() => store.state.userInfo || {});
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([isMobile.value ? 'container' : 'containerPc'])
      }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).go(-1))
      }, _hoisted_4), _createTextVNode(" 我的阅读能力 ")]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createTextVNode(" Lv" + _toDisplayString(userInfo.value.level) + " ", 1), _createElementVNode("div", null, [_createElementVNode("span", {
        style: _normalizeStyle({
          width: userInfo.value.level / 396 * 100 + '%'
        })
      }, null, 4)])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).push({
          name: 'index',
          query: {
            pid: _ctx.pid
          }
        }))
      }, [_hoisted_8, _createTextVNode(" 原版阅读 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        onClick: _cache[2] || (_cache[2] = $event => _unref(router).push({
          name: 'photo',
          query: {
            pid: _ctx.getLocalPid()
          }
        }))
      }, [_hoisted_9, _createTextVNode(" AI工具 ")]), _createElementVNode("a", {
        href: "javascript: void(0)",
        style: {
          "color": "#35b9ff"
        },
        onClick: _cache[3] || (_cache[3] = $event => _unref(router).push({
          name: 'my',
          query: {
            pid: _ctx.getLocalPid()
          }
        }))
      }, [_hoisted_10, _createTextVNode(" 个人中心 ")])])])], 2);
    };
  }
};